import React from 'react';
import SortableTableHeaderCell from './SortableTableHeaderCell.jsx';

const SortableTableHeaderRow = ({
  children,
  ...props
}) => (
  <tr>
    {
      React.Children.map(children, (child) => {
        if (child.type === SortableTableHeaderCell) {
          return cloneSortableChild(child, props);
        }

        return child;
      })
    }
  </tr>
);

function cloneSortableChild(child, {
  onSort,
  sortDirection,
  sortKey,
}) {
  let newChildProps = {
    onSort: (direction) => {
      onSort(direction, child.props.sortKey);
    },
    direction: (child.props.sortKey === sortKey) ? sortDirection : null,
  };

  return React.cloneElement(child, newChildProps);
}

export default SortableTableHeaderRow;
